function SiteSelector({ selectedSite, onSelect }) {
    return (
    <div className="select-box"> 
      <select value={selectedSite} onChange={e => onSelect(e.target.value)}>
        <option value="google">Google</option>
        <option value="youtube">YouTube</option>
        <option value="bing">Bing</option>
        <option value="amazon">Amazon</option>
        <option value="x">X(Twitter)</option>
      </select>
    </div>
    );
  }

  export default SiteSelector;